import { useState } from "react";
import { MainLayoutContainer } from "components/Layout";
import {
  HospitalFeedbackCompetitionWidget,
  MetricsDateRangeFilter,
} from "pages/Metrics/components";
import {
  DEFAULT_METRICS_DATE_RANGE,
  MetricsDateRange,
} from "pages/Metrics/metricsDateRange";

export const HospitalCompetition = () => {
  const [dateRange, setDateRange] = useState<MetricsDateRange>(
    DEFAULT_METRICS_DATE_RANGE,
  );

  return (
    <MainLayoutContainer
      title="Hospital competition rankings"
      description="View the complete rankings for all organization domains you have access to. Percentages remain private."
      buttonActions={
        <MetricsDateRangeFilter value={dateRange} onChange={setDateRange} />
      }
    >
      <HospitalFeedbackCompetitionWidget dateRange={dateRange} showAll />
    </MainLayoutContainer>
  );
};
